module.exports = __webpack_public_path__ + "static/media/infested-mass.e591bde1.svg";